import { Fragment, memo, useEffect, useCallback, useMemo, useState } from 'react';
import Modal from 'react-modal';
import { asyncDebouncer } from '../../utils/helper';
import { Autocomplete, TextField } from '@mui/material';

Modal.setAppElement('#chat_cont');

const DEBOUNCE_DELAY = 500;

const NewMessageUserMultiSelect = ({
    newMsgSendSelected,
    setNewMsgSendSelected,
    disabled,
    label = "Send To"
}) => {
    const [gettingSubscriberList, setGettingSubscriberList] = useState(false);
    const [searchOptions, setSearchOptions] = useState([]);
    const [keyword, setKeyword] = useState('a');

    const getUserOptions = async (
        cancelToken,
    ) => {
        if (typeof cancelToken !== typeof undefined) {
            cancelToken.cancel('Operation canceled due to new request.');
        }
        setGettingSubscriberList(true);
        await axios.get('/api/messages/follower-search', {
            params: {
                login: keyword,
            },
        }, { cancelToken: cancelToken.token })
            .then((response) => {
                setGettingSubscriberList(false);
                setSearchOptions(response.data);
            })
            .catch((error) => {
                console.log('NewMessageUserMultiSelect > getUserOptions > error', error);
                setGettingSubscriberList(false);
            });
    };

    let newMessageModal = null;
    let newMessageMultiSelectOptionsDisplayNone = null;
    let searchBar = null;

    useEffect(() => {
        // document.body.style.overflow = 'hidden';

        setTimeout(() => {
            newMessageModal = document.querySelector('.ReactModalPortal');

            if (newMessageModal) {
                searchBar = newMessageModal.querySelector('#newSendList');

                if (searchBar) {
                    searchBar.addEventListener("mousedown", handleClickNewMessageModal);
                    searchBar = null;
                }
            }
        }, 100);

        return () => {
            // document.body.style.overflow = 'auto';

            if (searchBar) {
                searchBar.removeEventListener("mousedown", handleClickNewMessageModal);
                searchBar = null;
            }
        };
    }, []);

    function handleClickNewMessageModal(event) {
        // set newMessageMultiSelectOptionsDisplayNone if it is null
        if (!newMessageMultiSelectOptionsDisplayNone) {
            newMessageMultiSelectOptionsDisplayNone = document.querySelector('.optionListContainer.displayNone');
        }

        // check if multiselect options are displayed and retrieve user options
        if (newMessageMultiSelectOptionsDisplayNone) {
            const cancelToken = axios.CancelToken.source();
            getUserOptions(cancelToken);
        }
    }

    const handleKeypress = e => {
        if (e.key === "Enter") {
            e.preventDefault();
        }
    };

    useEffect(() => {
        if (keyword) {
            const cancelToken = axios.CancelToken.source();
            getUserOptions(cancelToken);
        }
    }, [keyword]);

    const handleInputChange = asyncDebouncer((event, newInputValue) => {
        console.log({ newInputValue });
        setKeyword(newInputValue);
    }, DEBOUNCE_DELAY);

    const handleSelect = (e, value, reason) => {
        console.log({ e, value, reason });
        setNewMsgSendSelected([...value]);
    };

    const filterOptions = (options, { inputValue }) => {
        const selectedIDs = newMsgSendSelected.map(item => item.id);
        const filteredOptions = options.filter((option) => !selectedIDs.includes(option.id));

        if (inputValue !== '') {
            // Optionally, you can further filter based on the inputValue
            return filteredOptions.filter((option) =>
                option.name.toLowerCase().includes(inputValue.toLowerCase())
            );
        }
        return filteredOptions;
    };

    return (
        <Fragment>
            <Autocomplete
                multiple
                filterSelectedOptions
                options={searchOptions}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="outlined"
                        label={label}
                        placeholder="Search"
                        size='small'
                    />
                )}
                onInputChange={handleInputChange}
                filterOptions={filterOptions}
                onKeyDown={handleKeypress}
                onChange={handleSelect}
                size='small'
                loading={gettingSubscriberList}
                loadingText='Getting subscribers'
                value={newMsgSendSelected}
                sx={{
                    '& .MuiOutlinedInput-root': {
                        borderRadius: '20px', // Adjust the value to control the roundness
                    },
                }}
            />
        </Fragment>
    );
};

export default (memo(NewMessageUserMultiSelect));
